import React, { useEffect, useState, createElement } from 'react';
import { CheckIcon, ShieldCheckIcon, LockIcon, CreditCardIcon, ZapIcon, UsersIcon, FileTextIcon, XIcon } from 'lucide-react';
import { CountdownTimer } from './components/CountdownTimer';
import { FAQItem } from './components/FAQItem';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  const [selectedPack, setSelectedPack] = useState<'elite' | 'base'>('elite');
  const scrollToPricing = (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
    e.preventDefault();
    const packSection = document.getElementById('elegi-tu-pack');
    if (packSection) {
      packSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  useEffect(() => {
    // Meta Pixel
    const w = window as any;
    if (!w.fbq) {
      const n: any = w.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
    }
    w.fbq('init', '804808849254877');
    w.fbq('track', 'PageView');
  }, []);
  const trackAddToCart = () => {
    const w = window as any;
    if (w.fbq) w.fbq('track', 'AddToCart');
  };
  return <div className="min-h-screen bg-[#2C3E50] font-['Lato',sans-serif] text-white" data-id="element-0">
      {/* HERO SECTION */}
      <section className="pt-8 pb-10 px-4 bg-[#2C3E50] text-white overflow-hidden relative" data-id="element-1">
        <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-2">
          <h2 className="font-['Montserrat',sans-serif] font-bold text-xl md:text-2xl tracking-widest mb-8 text-[#F39C12]" data-id="element-3">
            💑 NUVORA PLUS™
          </h2>

          <h1 className="font-['Montserrat',sans-serif] font-bold text-3xl md:text-[40px] leading-tight mb-4 text-white max-w-4xl mx-auto" data-id="element-4">
            Transformá tu relación en{' '}
            <span className="text-[#F39C12]" data-id="element-5">24 horas</span>, antes de que sea
            demasiado tarde.
          </h1>

          <h2 className="font-['Montserrat',sans-serif] font-bold text-xl md:text-[22px] text-[#E74C3C] mb-8" data-id="element-6">
            SIN MESES DE TERAPIA
          </h2>

          <div className="relative mx-auto w-full max-w-2xl mb-8" data-id="element-7">
            <div className="absolute inset-0 bg-[#27AE60]/20 blur-3xl rounded-full" data-id="element-8"></div>
            <img src="https://cdn.magicpatterns.com/uploads/7deytoNYMVyxwgU6pKA1nd/private_openrouter-generated-image-1775764806142.png" alt="Mockup del Método Reset 24h + Todo Incluido" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-9" />
          </div>

          <p className="text-lg md:text-[18px] text-gray-200 max-w-3xl mx-auto mb-8 leading-relaxed" data-id="element-10">
            El sistema paso a paso para frenar el conflicto, recuperar la calma
            y volver a ser equipo, sin largos procesos de terapia
          </p>

          <div className="flex flex-wrap justify-center gap-3 md:gap-4 text-[14px] font-semibold mb-10" data-id="element-11">
            <div className="flex items-center gap-2 border border-white/30 rounded-full px-5 py-2.5" data-id="element-12">
              <span data-id="element-13">📄</span>
              <span data-id="element-14">100% PDF</span>
            </div>
            <div className="flex items-center gap-2 border border-white/30 rounded-full px-5 py-2.5" data-id="element-15">
              <span className="text-[#F39C12]" data-id="element-16">⚡</span>
              <span data-id="element-17">Acceso en 5 min</span>
            </div>
            <div className="flex items-center gap-2 border border-white/30 rounded-full px-5 py-2.5" data-id="element-18">
              <span data-id="element-19">💑</span>
              <span data-id="element-20">Para parejas</span>
            </div>
            <div className="flex items-center gap-2 border border-white/30 rounded-full px-5 py-2.5" data-id="element-21">
              <span data-id="element-22">🛡️</span>
              <span data-id="element-23">Todo incluido</span>
            </div>
          </div>

          <div className="space-y-5" data-id="element-24">
            <button onClick={scrollToPricing} className="bg-[#27AE60] hover:bg-[#229954] text-white px-10 py-5 rounded-xl font-['Montserrat',sans-serif] font-bold text-[20px] shadow-xl hover:shadow-2xl transition-all animate-pulse inline-block" data-id="element-25">
              → QUIERO MI MÉTODO RESET 24 H. AHORA
            </button>
            <p className="text-[14px] text-gray-300 flex items-center justify-center gap-4" data-id="element-26">
              <span className="flex items-center gap-1.5" data-id="element-27">
                🛡️ Garantía 7 días
              </span>
              <span className="flex items-center gap-1.5" data-id="element-28">🔒 Pago seguro</span>
              <span className="flex items-center gap-1.5" data-id="element-29">💳 Mercado Pago</span>
            </p>
          </div>
        </div>
      </section>

      {/* 3. STATS + TESTIMONIALS (dark section) */}
      <section className="py-10 px-4 bg-[#1a2636]" data-id="element-30">
        <div className="max-w-6xl mx-auto" data-id="element-31">
          {/* Stats Row */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center mb-10" data-id="element-32">
            <div data-id="element-33">
              <div className="font-['Montserrat',sans-serif] font-bold text-[42px] text-white" data-id="element-34">
                +500
              </div>
              <div className="text-[14px] text-[#F39C12]" data-id="element-35">
                parejas lo usaron
              </div>
            </div>
            <div data-id="element-36">
              <div className="font-['Montserrat',sans-serif] font-bold text-[42px] text-white" data-id="element-37">
                180
              </div>
              <div className="text-[14px] text-[#F39C12]" data-id="element-38">páginas listas</div>
            </div>
            <div data-id="element-39">
              <div className="font-['Montserrat',sans-serif] font-bold text-[42px] text-white" data-id="element-40">
                4
              </div>
              <div className="text-[14px] text-[#F39C12]" data-id="element-41">Bonos incluidos</div>
            </div>
            <div data-id="element-42">
              <div className="font-['Montserrat',sans-serif] font-bold text-[42px] text-white" data-id="element-43">
                4.9/5
              </div>
              <div className="text-[14px] text-[#F39C12]" data-id="element-44">calificación ⭐</div>
            </div>
          </div>

          {/* Testimonial Cards */}
          <div className="grid md:grid-cols-3 gap-6" data-id="element-45">
            <div className="bg-[#1e2d42] border border-[#2C3E50] rounded-xl p-6" data-id="element-46">
              <div className="flex items-center gap-3 mb-3" data-id="element-47">
                <div className="w-10 h-10 rounded-full bg-[#F39C12] flex items-center justify-center font-['Montserrat',sans-serif] font-bold text-white text-sm" data-id="element-48">
                  VG
                </div>
                <div className="text-[#F39C12] text-sm" data-id="element-49">⭐⭐⭐⭐⭐</div>
              </div>
              <p className="text-[15px] text-gray-200 mb-3 leading-relaxed" data-id="element-50">
                "En una tarde organizamos todo lo que no pudimos hablar en
                meses."
              </p>
              <p className="text-sm font-bold text-gray-400" data-id="element-51">
                — Valentina G., Córdoba
              </p>
            </div>
            <div className="bg-[#1e2d42] border border-[#2C3E50] rounded-xl p-6" data-id="element-52">
              <div className="flex items-center gap-3 mb-3" data-id="element-53">
                <div className="w-10 h-10 rounded-full bg-[#F39C12] flex items-center justify-center font-['Montserrat',sans-serif] font-bold text-white text-sm" data-id="element-54">
                  LP
                </div>
                <div className="text-[#F39C12] text-sm" data-id="element-55">⭐⭐⭐⭐⭐</div>
              </div>
              <p className="text-[15px] text-gray-200 mb-3 leading-relaxed" data-id="element-56">
                "La Auditoría de pensamientos me hizo ver cosas que yo no veía."
              </p>
              <p className="text-sm font-bold text-gray-400" data-id="element-57">
                — Laura P., Rosario
              </p>
            </div>
            <div className="bg-[#1e2d42] border border-[#2C3E50] rounded-xl p-6" data-id="element-58">
              <div className="flex items-center gap-3 mb-3" data-id="element-59">
                <div className="w-10 h-10 rounded-full bg-[#F39C12] flex items-center justify-center font-['Montserrat',sans-serif] font-bold text-white text-sm" data-id="element-60">
                  RM
                </div>
                <div className="text-[#F39C12] text-sm" data-id="element-61">⭐⭐⭐⭐⭐</div>
              </div>
              <p className="text-[15px] text-gray-200 mb-3 leading-relaxed" data-id="element-62">
                "El Nuevo Contrato de Pareja fue lo más honesto que hicimos en
                años."
              </p>
              <p className="text-sm font-bold text-gray-400" data-id="element-63">
                — Roberto M., Buenos Aires
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 5. PAIN POINTS SECTION */}
      <section className="py-10 px-4 bg-[#2C3E50]" data-id="element-64">
        <div className="max-w-3xl mx-auto" data-id="element-65">
          <h2 className="font-['Montserrat',sans-serif] font-bold text-[28px] text-white mb-4 text-center" data-id="element-66">
            ¿Cuántos días más van a seguir así?
          </h2>
          <p className="text-[17px] text-gray-300 mb-4 leading-relaxed text-center" data-id="element-67">
            Querés salvar tu relación. O al menos entender qué pasó. Pero nadie
            te dijo que iba a ser tan difícil encontrar por dónde empezar.
          </p>
          <p className="font-['Montserrat',sans-serif] font-bold text-[22px] text-[#27AE60] mb-10 text-center" data-id="element-68">
            No es falta de amor. Es falta de un sistema.
          </p>

          <div className="space-y-4 mb-12" data-id="element-69">
            {['Noches sin dormir rumiando la misma discusión sin resolución', 'Conversaciones que empiezan bien y terminan peor que antes', 'Silencios que duran días y nadie sabe cómo romperlos', 'Sintiéndote solo/a aunque estés en pareja', 'Buscando en Google "cómo salvar mi relación" y encontrando solo cosas genéricas', 'El mismo ciclo: pelea → silencio → fingir que está bien → volver a pelear'].map((pain, idx) => <div key={idx} className="bg-[#3a1a1a]/60 border border-[#E74C3C]/30 rounded-xl px-6 py-5 flex items-center gap-4" data-id="element-70">
                <XIcon className="w-7 h-7 text-[#E74C3C] flex-shrink-0" data-id="element-71" />
                <p className="text-[17px] text-gray-200 leading-relaxed" data-id="element-72">
                  {pain}
                </p>
              </div>)}
          </div>

          <h3 className="font-['Montserrat',sans-serif] font-bold italic text-[22px] text-[#27AE60] text-center" data-id="element-73">
            ¿Y si este fuera el último día que siguen así?
          </h3>

          <div className="mt-10 flex justify-center" data-id="element-74">
            <div className="border border-[#27AE60]/40 rounded-full px-8 py-3" data-id="element-75">
              <p className="font-['Montserrat',sans-serif] font-bold text-sm md:text-base text-white tracking-wider text-center" data-id="element-76">
                🏆 MÉTODO RESET 24 H. — NUVORA PLUS™
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 6. PRODUCT PRESENTATION */}
      <section className="py-12 px-4 bg-[#1a2636]" data-id="element-77">
        <div className="max-w-4xl mx-auto bg-[#1e2d42] rounded-2xl shadow-xl overflow-hidden border border-[#2C3E50]" data-id="element-78">
          <div className="p-6 md:p-10" data-id="element-79">
            <h3 className="font-bold text-[18px] text-white mb-3 flex items-center gap-2" data-id="element-80">
              <span className="text-2xl" data-id="element-81">📘</span> 180 páginas — El protocolo
              completo
            </h3>

            <p className="text-[17px] text-gray-300 mb-6 leading-relaxed" data-id="element-82">
              El plan paso a paso para que una pareja en crisis pueda frenar,
              entenderse y reconectar en menos de 24 horas. Sin terapia previa.
              Sin experiencia. Solo seguir el sistema.
            </p>

            <div className="flex flex-wrap gap-3" data-id="element-83">
              {['Protocolo de desescalada', 'La Rueda de la Satisfacción', 'Guía de comunicación asertiva', 'El Nuevo Contrato de Pareja', 'Auditoría de pensamientos', '100% adaptado a la pareja argentina', 'Lenguaje claro, sin términos técnicos', 'Listo para usar solos, sin terapeuta'].map((item, idx) => <div key={idx} className="flex items-center gap-2 bg-[#27AE60]/20 border border-[#27AE60]/50 rounded-full px-4 py-2" data-id="element-84">
                  <CheckIcon className="w-4 h-4 text-[#27AE60] flex-shrink-0" data-id="element-85" />
                  <span className="text-[15px] text-white font-medium" data-id="element-86">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* 7. BONUSES SECTION */}
      <section className="py-12 px-4 bg-[#1a2636]" data-id="element-87">
        <div className="max-w-5xl mx-auto" data-id="element-88">
          <h2 className="font-['Montserrat',sans-serif] font-bold text-[28px] text-center mb-10" data-id="element-89">
            <span className="text-white" data-id="element-90">🎁 4 BONOS ESTRATÉGICOS —</span>{' '}
            <span className="text-[#F39C12]" data-id="element-91">SIEMPRE INCLUIDOS</span>
          </h2>

          <div className="grid md:grid-cols-2 gap-5 mb-10" data-id="element-92">
            {[{
            num: '01',
            title: 'Reconexión Íntima',
            desc: 'Despertá el deseo que se fue apagando con el tiempo. Ejercicios concretos para recuperar la intimidad física y emocional.',
            price: '$8.000'
          }, {
            num: '02',
            title: 'Intimidad Radical',
            desc: 'Recuperá la conexión sexual y emocional profunda con tu pareja.',
            price: '$9.000'
          }, {
            num: '03',
            title: 'Reconstrucción Individual',
            desc: 'Trabajá la ansiedad, el enojo y el miedo que te paralizan adentro de la relación.',
            price: '$8.000'
          }, {
            num: '04',
            title: 'Conexión Profunda',
            desc: 'La gratitud como herramienta real para transformar la dinámica diaria de tu pareja.',
            price: '$9.000'
          }].map((bono, idx) => <div key={idx} className="bg-[#1e2d42] border border-[#F39C12]/40 rounded-xl p-6" data-id="element-93">
                <div className="font-['Montserrat',sans-serif] font-bold text-[40px] text-[#F39C12] leading-none mb-1" data-id="element-94">
                  {bono.num}
                </div>
                <p className="text-[#F39C12] text-sm font-bold mb-3" data-id="element-95">
                  🎁 BONO {bono.num}
                </p>
                <h3 className="font-['Montserrat',sans-serif] font-bold text-lg text-white mb-2" data-id="element-96">
                  {bono.title}
                </h3>
                <p className="text-gray-300 text-sm mb-4 leading-relaxed" data-id="element-97">
                  {bono.desc}
                </p>
                <div className="flex items-center gap-3" data-id="element-98">
                  <span className="line-through text-gray-500 text-sm" data-id="element-99">
                    {bono.price}
                  </span>
                  <span className="bg-white text-[#2C3E50] font-['Montserrat',sans-serif] font-bold text-sm px-3 py-1 rounded" data-id="element-100">
                    GRATIS
                  </span>
                </div>
              </div>)}
          </div>

          <div className="max-w-2xl mx-auto mt-10 bg-[#1e2d42] border border-[#F39C12]/40 rounded-xl p-6 text-center shadow-lg" data-id="element-101">
            <p className="font-['Montserrat',sans-serif] font-bold text-[20px] text-[#F39C12]" data-id="element-102">
              Valor total bonos:{' '}
              <span className="line-through text-gray-400" data-id="element-103">$34.000</span> →
              GRATIS con tu Método RESET 24 H.
            </p>
          </div>
        </div>
      </section>

      {/* 8. COUNTDOWN + PRICING SECTION */}
      <section className="py-12 px-4 bg-[#2C3E50]" data-id="element-104">
        <div className="max-w-4xl mx-auto" data-id="element-105">
          {/* Countdown Box */}
          <div className="bg-[#2a1015] rounded-2xl p-8 md:p-10 text-center shadow-xl mb-10" data-id="element-106">
            <h3 className="font-['Montserrat',sans-serif] font-bold text-xl md:text-2xl text-white mb-8 uppercase tracking-wider" data-id="element-107">
              ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
            </h3>
            <div className="flex justify-center mb-8" data-id="element-108">
              <CountdownTimer initialMinutes={15} showLabels={true} data-id="element-109" />
            </div>
            <p className="font-bold text-[17px] text-white mb-8" data-id="element-110">
              ⚠️ Después sube <span className="text-[#F39C12]" data-id="element-111">$8.000 ARS</span>
              . No vuelve.
            </p>
            <div className="max-w-lg mx-auto" data-id="element-112">
              <div className="flex items-center justify-between mb-2" data-id="element-113">
                <span className="text-sm text-[#E74C3C] font-semibold flex items-center gap-1.5" data-id="element-114">
                  🔴 Cupos al precio de lanzamiento
                </span>
                <span className="text-sm text-gray-400 font-bold" data-id="element-115">
                  Quedan pocos
                </span>
              </div>
              <div className="w-full bg-gray-700 rounded-full h-3 overflow-hidden" data-id="element-116">
                <div className="h-3 rounded-full" style={{
                width: '68%',
                background: 'linear-gradient(to right, #E74C3C, #F39C12)'
              }} data-id="element-117"></div>
              </div>
              <p className="text-xs text-gray-500 mt-2 text-right" data-id="element-118">
                68% de los cupos al precio de lanzamiento ya tomados
              </p>
            </div>
          </div>

          <h2 id="elegi-tu-pack" className="font-['Montserrat',sans-serif] font-bold text-[28px] text-white text-center mb-10 scroll-mt-10" data-id="element-119">
            ELEGÍ TU MÉTODO RESET
          </h2>

          <div className="flex flex-col gap-4 max-w-2xl mx-auto" data-id="element-120">
            {/* PACK BASE */}
            <div onClick={() => setSelectedPack('base')} className={`bg-[#1e2d42] rounded-xl p-5 flex items-start gap-4 cursor-pointer transition-all ${selectedPack === 'base' ? 'border-2 border-[#27AE60] shadow-lg' : 'border-2 border-[#444444]'}`} data-id="element-121">
              <div className="mt-1" data-id="element-122">
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${selectedPack === 'base' ? 'border-[#27AE60]' : 'border-gray-500'}`} data-id="element-123">
                  {selectedPack === 'base' && <div className="w-2.5 h-2.5 rounded-full bg-[#27AE60]" data-id="element-124"></div>}
                </div>
              </div>
              <div className="flex-1" data-id="element-125">
                <h3 className="font-['Montserrat',sans-serif] font-bold text-lg text-white" data-id="element-126">
                  💑 MÉTODO RESET 24 H.
                </h3>
                <p className="text-gray-300 text-sm mt-1" data-id="element-127">Método + 4 Bonos</p>
              </div>
              <div className="text-right flex-shrink-0" data-id="element-128">
                <span className="text-gray-500 line-through text-sm block" data-id="element-129">
                  $53.990
                </span>
                <span className="font-['Montserrat',sans-serif] font-bold text-[28px] text-white" data-id="element-130">
                  $19.990 <span className="text-[16px]" data-id="element-131">ARS</span>
                </span>
              </div>
            </div>

            {/* PACK ELITE */}
            <div onClick={() => setSelectedPack('elite')} className={`bg-[#1e2d42] rounded-xl p-5 flex items-start gap-4 cursor-pointer transition-all ${selectedPack === 'elite' ? 'border-2 border-[#27AE60] shadow-lg' : 'border-2 border-[#444444]'}`} data-id="element-132">
              <div className="mt-1" data-id="element-133">
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${selectedPack === 'elite' ? 'border-[#27AE60]' : 'border-gray-500'}`} data-id="element-134">
                  {selectedPack === 'elite' && <div className="w-2.5 h-2.5 rounded-full bg-[#27AE60]" data-id="element-135"></div>}
                </div>
              </div>
              <div className="flex-1" data-id="element-136">
                <h3 className="font-['Montserrat',sans-serif] font-bold text-lg text-white" data-id="element-137">
                  🏆 MÉTODO RESET 24 H. + LOS 5 ERRORES ⭐
                </h3>
                <p className="text-gray-300 text-sm mt-1" data-id="element-138">
                  Método + 4 Bonos + Los 5 Errores Silenciosos que Destrozan
                  Parejas
                </p>
              </div>
              <div className="text-right flex-shrink-0" data-id="element-139">
                <span className="text-gray-500 line-through text-sm block" data-id="element-140">
                  $69.990
                </span>
                <span className="font-['Montserrat',sans-serif] font-bold text-[28px] text-[#F39C12]" data-id="element-141">
                  $27.990 <span className="text-[16px]" data-id="element-142">ARS</span>
                </span>
              </div>
            </div>

            {/* SINGLE CTA BUTTON */}
            <button onClick={() => {
            trackAddToCart();
            window.open(selectedPack === 'elite' ? 'https://checkout.nuvoraplus.online/cart/53422556217712:1' : 'https://checkout.nuvoraplus.online/cart/53422554972528:1', '_blank');
          }} className="w-full bg-[#27AE60] hover:bg-[#229954] text-white py-5 rounded-xl font-['Montserrat',sans-serif] font-bold text-[20px] transition-colors shadow-lg mt-4" data-id="element-143">
              {selectedPack === 'elite' ? '→ QUIERO EL MÉTODO RESET + LOS 5 ERRORES' : '→ QUIERO EL MÉTODO RESET'}
            </button>
          </div>
        </div>
      </section>

      {/* 8B. QUÉ AGREGA LOS 5 ERRORES */}
      <section className="py-10 px-4 bg-[#2C3E50]" data-id="element-144">
        <div className="max-w-4xl mx-auto" data-id="element-145">
          <h2 className="font-['Montserrat',sans-serif] font-bold text-[24px] md:text-[28px] text-white text-center mb-10" data-id="element-146">
            🧠 ¿QUÉ AGREGA{' '}
            <span className="text-[#F39C12]" data-id="element-147">
              "LOS 5 ERRORES SILENCIOSOS QUE DESTROZAN PAREJAS"
            </span>
            ?
          </h2>

          <div className="overflow-x-auto rounded-xl border border-[#27AE60]/30 shadow-lg" data-id="element-148">
            <table className="w-full text-left border-collapse" data-id="element-149">
              <thead data-id="element-150">
                <tr className="bg-[#1a2636]" data-id="element-151">
                  <th className="p-4 font-['Montserrat',sans-serif] font-bold text-[15px] text-white w-1/3 border-r border-[#2C3E50]" data-id="element-152">
                    Situación en la pareja
                  </th>
                  <th className="p-4 font-['Montserrat',sans-serif] font-bold text-[15px] text-center w-1/3 border-r border-[#2C3E50]" data-id="element-153">
                    <span className="text-red-400" data-id="element-154">❌ Sin el libro</span>
                  </th>
                  <th className="p-4 font-['Montserrat',sans-serif] font-bold text-[15px] text-center w-1/3" data-id="element-155">
                    <span className="text-[#27AE60]" data-id="element-156">✅ Con el libro</span>
                  </th>
                </tr>
              </thead>
              <tbody className="text-[15px] text-gray-200" data-id="element-157">
                <tr className="bg-[#1e2d42] border-t border-[#2C3E50]" data-id="element-158">
                  <td className="p-4 border-r border-[#2C3E50] font-medium text-white" data-id="element-159">
                    Sienten que viven en mundos distintos
                  </td>
                  <td className="p-4 border-r border-[#2C3E50] text-gray-400" data-id="element-160">
                    Pelean sin entender por qué
                  </td>
                  <td className="p-4 text-gray-200" data-id="element-161">
                    Capítulo "Realidades Paralelas": entendés los universos
                    subjetivos y el peligro de las generalizaciones.
                  </td>
                </tr>
                <tr className="bg-[#1a2636] border-t border-[#2C3E50]" data-id="element-162">
                  <td className="p-4 border-r border-[#2C3E50] font-medium text-white" data-id="element-163">
                    La rutina los está matando
                  </td>
                  <td className="p-4 border-r border-[#2C3E50] text-gray-400" data-id="element-164">
                    Esperás que "algo cambie solo"
                  </td>
                  <td className="p-4 text-gray-200" data-id="element-165">
                    Capítulo "La Rutina y la Habituación": alertas frías y cómo
                    reinventar la conexión.
                  </td>
                </tr>
                <tr className="bg-[#1e2d42] border-t border-[#2C3E50]" data-id="element-166">
                  <td className="p-4 border-r border-[#2C3E50] font-medium text-white" data-id="element-167">
                    No se apoyan ni tienen metas juntos
                  </td>
                  <td className="p-4 border-r border-[#2C3E50] text-gray-400" data-id="element-168">
                    Cada uno tira para su lado
                  </td>
                  <td className="p-4 text-gray-200" data-id="element-169">
                    Capítulo "Falta de Apoyo y Visión": el mapa del futuro y el
                    diseño de metas compartidas.
                  </td>
                </tr>
                <tr className="bg-[#1a2636] border-t border-[#2C3E50]" data-id="element-170">
                  <td className="p-4 border-r border-[#2C3E50] font-medium text-white" data-id="element-171">
                    Comunicación pasivo-agresiva constante
                  </td>
                  <td className="p-4 border-r border-[#2C3E50] text-gray-400" data-id="element-172">
                    Ironías, silencios y resentimiento
                  </td>
                  <td className="p-4 text-gray-200" data-id="element-173">
                    Capítulo "Errores 4 y 5 + Manual Preventivo": la mesa sin
                    propósito y el calendario de 30 días.
                  </td>
                </tr>
                <tr className="bg-[#1e2d42] border-t border-[#2C3E50]" data-id="element-174">
                  <td className="p-4 border-r border-[#2C3E50] font-medium text-white" data-id="element-175">
                    Creen en el mito de la "media naranja"
                  </td>
                  <td className="p-4 border-r border-[#2C3E50] text-gray-400" data-id="element-176">
                    Frustración cuando la realidad no coincide
                  </td>
                  <td className="p-4 text-gray-200" data-id="element-177">
                    Introducción: la verdad detrás de los cuentos de hadas y
                    cómo construir algo real.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* 9. MORE TESTIMONIALS */}
      <section className="py-10 px-4 bg-[#1a2636]" data-id="element-178">
        <div className="max-w-5xl mx-auto" data-id="element-179">
          <h2 className="font-['Montserrat',sans-serif] font-bold text-[28px] text-white text-center mb-10" data-id="element-180">
            ❤️ MÁS PAREJAS QUE YA LO USARON
          </h2>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-181">
            <div className="bg-[#1e2d42] p-6 rounded shadow-sm border-l-4 border-[#27AE60]" data-id="element-182">
              <div className="text-[#F39C12] mb-2 text-lg" data-id="element-183">⭐⭐⭐⭐⭐</div>
              <p className="italic text-[16px] text-gray-200 mb-4" data-id="element-184">
                "El Protocolo de desescalada nos salvó en el momento más
                difícil. Lo leímos juntos a las 2 de la mañana y funcionó."
              </p>
              <p className="font-bold text-white" data-id="element-185">— Cecilia R. — 📍 Mendoza</p>
            </div>
            <div className="bg-[#1e2d42] p-6 rounded shadow-sm border-l-4 border-[#27AE60]" data-id="element-186">
              <div className="text-[#F39C12] mb-2 text-lg" data-id="element-187">⭐⭐⭐⭐⭐</div>
              <p className="italic text-[16px] text-gray-200 mb-4" data-id="element-188">
                "Llevábamos 3 meses sin poder hablar bien. Con la Guía de
                comunicación asertiva la primera conversación real en meses duró
                2 horas y terminó en abrazo."
              </p>
              <p className="font-bold text-white" data-id="element-189">
                — Martín y Sole — 📍 Buenos Aires
              </p>
            </div>
            <div className="bg-[#1e2d42] p-6 rounded shadow-sm border-l-4 border-[#27AE60]" data-id="element-190">
              <div className="text-[#F39C12] mb-2 text-lg" data-id="element-191">⭐⭐⭐⭐⭐</div>
              <p className="italic text-[16px] text-gray-200 mb-4" data-id="element-192">
                "La Rueda de la Satisfacción fue incómoda pero necesaria. Por
                fin los dos vimos lo mismo al mismo tiempo."
              </p>
              <p className="font-bold text-white" data-id="element-193">— Sofía C. — 📍 La Plata</p>
            </div>
            <div className="bg-[#1e2d42] p-6 rounded shadow-sm border-l-4 border-[#27AE60]" data-id="element-194">
              <div className="text-[#F39C12] mb-2 text-lg" data-id="element-195">⭐⭐⭐⭐⭐</div>
              <p className="italic text-[16px] text-gray-200 mb-4" data-id="element-196">
                "El Nuevo Contrato de Pareja sonaba raro, pero fue lo más
                honesto que hicimos en años."
              </p>
              <p className="font-bold text-white" data-id="element-197">— Pablo A. — 📍 Neuquén</p>
            </div>
          </div>
        </div>
      </section>

      {/* 10. GUARANTEE */}
      <section className="py-10 px-4 bg-[#2C3E50]" data-id="element-198">
        <div className="max-w-3xl mx-auto text-center" data-id="element-199">
          <ShieldCheckIcon className="w-16 h-16 text-[#3B82F6] mx-auto mb-6" data-id="element-200" />
          <h2 className="font-['Montserrat',sans-serif] font-bold italic text-[28px] md:text-[36px] text-[#27AE60] mb-8" data-id="element-201">
            GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>

          <div className="bg-[#1e2d42] border-2 border-[#27AE60] rounded-2xl p-8 md:p-10 mb-6" data-id="element-202">
            <p className="text-[17px] text-gray-200 leading-relaxed mb-4" data-id="element-203">
              Abrís el material. Lo usás con tu pareja.
            </p>
            <p className="text-[17px] text-gray-200 leading-relaxed mb-6" data-id="element-204">
              Si en <span className="font-bold text-[#F39C12]" data-id="element-205">7 días</span> no
              es lo que esperabas:
            </p>
            <p className="font-['Montserrat',sans-serif] font-bold italic text-[24px] md:text-[28px] text-[#F39C12] mb-4" data-id="element-206">
              devolución del 100%
            </p>
            <p className="text-[17px] font-bold text-white" data-id="element-207">
              sin formularios, sin drama.
            </p>
          </div>

          <p className="text-[15px] text-gray-400" data-id="element-208">
            Tasa de devoluciones:{' '}
            <span className="text-[#F39C12] font-bold" data-id="element-209">menos del 1%</span>.
          </p>
        </div>
      </section>

      {/* 11. FAQ ACCORDION */}
      <section className="py-10 px-4 bg-[#1a2636]" data-id="element-210">
        <div className="max-w-3xl mx-auto" data-id="element-211">
          <h2 className="font-['Montserrat',sans-serif] font-bold text-[28px] text-white text-center mb-10" data-id="element-212">
            ❓ LO QUE MÁS NOS PREGUNTAN
          </h2>
          <div className="space-y-3" data-id="element-213">
            <FAQItem question="¿Sirve si mi pareja no quiere participar?" answer="Sí, el cambio en tu reacción modifica la dinámica general. El método está diseñado para que puedas aplicar las herramientas vos solo/a y aun así generar cambios reales en la relación." data-id="element-214" />
            <FAQItem question="¿Cómo recibo el material?" answer="PDF descargable al instante en tu celular o tablet. Una vez que completás la compra, recibís un email con el link de descarga inmediata." data-id="element-215" />
            <FAQItem question="¿Necesitamos ir a terapia también?" answer="El Método Reset 24h está diseñado para darte herramientas prácticas inmediatas sin necesidad de terapia previa. Muchas parejas lo usan como alternativa o complemento a sus sesiones." data-id="element-216" />
            <FAQItem question="¿Tiene garantía real?" answer="Sí, tenés 7 días de garantía total. Si sentís que no te aportó nada, te devolvemos cada peso sin preguntas ni vueltas." data-id="element-217" />
          </div>
        </div>
      </section>

      {/* 12. COST COMPARISON TABLE */}
      <section className="py-10 px-4 bg-[#2C3E50]" data-id="element-218">
        <div className="max-w-4xl mx-auto" data-id="element-219">
          <h2 className="font-['Montserrat',sans-serif] font-bold text-[28px] text-white text-center mb-10" data-id="element-220">
            ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
          </h2>

          <div className="overflow-hidden rounded-xl border border-[#2C3E50] shadow-sm" data-id="element-221">
            <table className="w-full text-left border-collapse" data-id="element-222">
              <thead data-id="element-223">
                <tr className="bg-[#1a2636] text-white" data-id="element-224">
                  <th className="p-4 font-bold text-lg w-1/2 border-r border-[#2C3E50]" data-id="element-225">
                    Sin Método RESET
                  </th>
                  <th className="p-4 font-bold text-lg w-1/2" data-id="element-226">Costo real</th>
                </tr>
              </thead>
              <tbody className="text-[16px] text-gray-200" data-id="element-227">
                <tr className="bg-[#1e2d42]" data-id="element-228">
                  <td className="p-4 border-r border-[#2C3E50]" data-id="element-229">
                    Meses de peleas sin resolución
                  </td>
                  <td className="p-4" data-id="element-230">Desgaste emocional acumulado</td>
                </tr>
                <tr className="bg-[#1a2636]" data-id="element-231">
                  <td className="p-4 border-r border-[#2C3E50]" data-id="element-232">
                    Buscar en Google sin resultados
                  </td>
                  <td className="p-4" data-id="element-233">Más confusión, más distancia</td>
                </tr>
                <tr className="bg-[#1e2d42]" data-id="element-234">
                  <td className="p-4 border-r border-[#2C3E50]" data-id="element-235">
                    Terapia de pareja
                  </td>
                  <td className="p-4 font-bold text-white" data-id="element-236">
                    $40.000 por sesión
                  </td>
                </tr>
                <tr className="bg-[#1a2636]" data-id="element-237">
                  <td className="p-4 border-r border-[#2C3E50]" data-id="element-238">
                    Silencio que se vuelve costumbre
                  </td>
                  <td className="p-4" data-id="element-239">
                    La relación se enfría sin que nadie la frene
                  </td>
                </tr>
                <tr className="bg-[#1e2d42]" data-id="element-240">
                  <td className="p-4 border-r border-[#2C3E50] font-bold text-white" data-id="element-241">
                    Seguir el mismo ciclo
                  </td>
                  <td className="p-4 font-bold text-[#E74C3C]" data-id="element-242">
                    Lo que no se trabaja hoy, se rompe mañana
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* 13. SECOND PRICING SECTION */}
      <section className="py-12 px-4 bg-[#1a2636]" data-id="element-243">
        <div className="max-w-4xl mx-auto" data-id="element-244">
          <h3 className="font-['Montserrat',sans-serif] font-bold italic text-[24px] md:text-[28px] text-[#27AE60] text-center mb-10" data-id="element-245">
            El próximo día puede ser diferente.
          </h3>

          <div className="bg-[#1e2d42] border border-[#2C3E50] rounded-2xl p-6 md:p-8 shadow-2xl mb-8" data-id="element-246">
            <div className="text-center mb-8" data-id="element-247">
              <div className="inline-flex items-center gap-2 bg-red-500/10 text-red-400 px-4 py-2 rounded-full font-bold text-sm mb-4" data-id="element-248">
                <span data-id="element-249">⏰</span> EL PRECIO CIERRA EN:
              </div>
              <CountdownTimer data-id="element-250" />
            </div>

            <div className="grid md:grid-cols-2 gap-6" data-id="element-251">
              {/* PACK BASE */}
              <div className="bg-[#1a2636] border border-[#2C3E50] rounded-xl p-6 flex flex-col text-center" data-id="element-252">
                <h3 className="font-['Montserrat',sans-serif] font-bold text-lg text-white mb-2" data-id="element-253">
                  💑 MÉTODO RESET 24 H.
                </h3>
                <p className="text-gray-400 text-sm mb-6" data-id="element-254">Método + 4 Bonos</p>

                <div className="mt-auto" data-id="element-255">
                  <div className="mb-4" data-id="element-256">
                    <span className="text-gray-500 line-through text-sm block" data-id="element-257">
                      $53.990
                    </span>
                    <span className="font-['Montserrat',sans-serif] font-bold text-[28px] text-[#27AE60]" data-id="element-258">
                      $19.990 ARS
                    </span>
                  </div>

                  <button onClick={() => {
                  trackAddToCart();
                  window.open('https://checkout.nuvoraplus.online/cart/53422554972528:1', '_blank');
                }} className="w-full bg-[#27AE60] hover:bg-[#229954] text-white py-4 rounded-lg font-['Montserrat',sans-serif] font-bold text-[16px] transition-colors" data-id="element-259">
                    → QUIERO MI MÉTODO RESET
                  </button>
                </div>
              </div>

              {/* PACK ELITE */}
              <div className="bg-[#1a2636] border-2 border-[#27AE60] rounded-xl p-6 flex flex-col text-center relative shadow-lg" data-id="element-260">
                <h3 className="font-['Montserrat',sans-serif] font-bold text-lg text-white mb-2" data-id="element-261">
                  🏆 MÉTODO RESET 24 H. + LOS 5 ERRORES ⭐
                </h3>
                <p className="text-gray-400 text-sm mb-6" data-id="element-262">
                  Método + 4 Bonos + Los 5 Errores
                </p>

                <div className="mt-auto" data-id="element-263">
                  <div className="mb-4" data-id="element-264">
                    <span className="text-gray-500 line-through text-sm block" data-id="element-265">
                      $69.990
                    </span>
                    <span className="font-['Montserrat',sans-serif] font-bold text-[28px] text-[#27AE60]" data-id="element-266">
                      $27.990 ARS
                    </span>
                  </div>

                  <button onClick={() => {
                  trackAddToCart();
                  window.open('https://checkout.nuvoraplus.online/cart/53422556217712:1', '_blank');
                }} className="w-full bg-[#27AE60] hover:bg-[#229954] text-white py-4 rounded-lg font-['Montserrat',sans-serif] font-bold text-[16px] transition-colors shadow-lg" data-id="element-267">
                    → QUIERO EL MÉTODO RESET + LOS 5 ERRORES
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* TRUST BAR (Now inside the second pricing section) */}
          <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-[13px] text-gray-400 font-medium mt-6" data-id="element-268">
            <div className="flex items-center gap-2" data-id="element-269">
              <LockIcon className="w-4 h-4 text-[#F39C12]" data-id="element-270" />
              <span data-id="element-271">Pago 100% seguro</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-272">
              <ZapIcon className="w-4 h-4 text-[#E74C3C]" data-id="element-273" />
              <span data-id="element-274">Acceso en 5 minutos</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-275">
              <ShieldCheckIcon className="w-4 h-4 text-[#3B82F6]" data-id="element-276" />
              <span data-id="element-277">Garantía 7 días</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-278">
              <CreditCardIcon className="w-4 h-4 text-[#3B82F6]" data-id="element-279" />
              <span data-id="element-280">Mercado Pago</span>
            </div>
          </div>
        </div>
      </section>

      {/* 14. FOOTER */}
      <Footer data-id="element-281" />

      {/* 15. SOCIAL PROOF POPUP */}
      <SocialProofPopup data-id="element-282" />
    </div>;
}